import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

import Login from '@/components/user/Login'
import AppTabs from '@/components/AppTabs'
import Index from '@/components/Index'
import Create from '@/components/Create'
import Edit from '@/components/Edit'
//import Dashboard from "@/components/Dashboard";

import { dashboard } from '@/router/modules/dashboard.js'
import { customers } from '@/router/modules/customers.js'
import { products } from '@/router/modules/products.js'
import { fidelitycards } from '@/router/modules/fidelitycards.js'
import { calendar } from '@/router/modules/calendar.js'
import { users } from '@/router/modules/users.js'
import { statistics } from '@/router/modules/statistics.js'
import { settings } from '@/router/modules/settings.js'

export { AppTabs, Edit, Create, Index, store }

Vue.use(Router)

export function ifNotAuthenticated(to, from, next) {
	if (!store.getters.isAuthenticated) {
		next()
		return
	}
	next('/')
}

export function ifAuthenticated(to, from, next) {
	if (store.getters.isAuthenticated) {
		next()
		return
	}
	if (from.name == 'login') {
		store.commit('endProgress')
	}
	next('/login')
}

export function ifAuthenticatedOnline(to, from, next) {
	if (store.getters.isOnline && store.getters.isAuthenticated) {
		next()
		return
	}
	next('/login')
}

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		...dashboard,
		...customers,
		...products,
		...fidelitycards,
		...calendar,
		...users,
		...statistics,
		...settings,
		{
			path: '/',
			redirect: '/dashboard'
		},
		{
			path: '/login',
			name: 'login',
			component: Login,
			beforeEnter: ifNotAuthenticated
		},
		{
			path: '*',
			redirect: '/dashboard'
		}
	  
	]
})
